import {get_token, get_user_details} from "@/router";
import Swal from 'sweetalert2';
import Loader from "@/components/Loader/LoaderView";


export default {
  components: { Loader },
  props: {
    is_public: {
      type: Boolean,
      default: false,
    },
    portal_admin: {
      type: Boolean,
      default: false,
    },
    portal_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return ({
      positions: [],
      loading: false,
      user_details: null,
      token_exists: null,
      showEditModal: false,
      showAll: false,
      visibleCount: 4,
      editingPosition: {
        id: null,
        newName: ''
      },
      selected_position: null,
      portalUsers: [],
      assignForm: {
        userId: '',
      },
      errors: {},
      position_name: '',
    });
  },
  computed: {
    visiblePositions() {
      if (this.showAll) return this.positions;
      return this.positions.slice(0, this.visibleCount);
    },
  },

  mounted() {
    this.user_details = get_user_details();
    this.token_exists = get_token();
    this.fetch_portal_position();
    // Add event listener to clear form when modal is closed
    $('#create_position').on('hidden.bs.modal', this.clearCreateForm);
  },
  beforeUnmount() {
    $('#create_position').off('hidden.bs.modal', this.clearCreateForm);
    if ($.fn.DataTable.isDataTable('#assignPositionTable')) {
      $('#assignPositionTable').DataTable().destroy();
    }
  },
  methods: {
    clearCreateForm() {
      this.position_name = '';
      this.errors = {};
    },
    getToken() {
      return get_token();
    },
    toggleShowMore() {
      this.showAll = !this.showAll;
    },
    fetch_portal_position() {
      this.loading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_position/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          portal_id: this.portal_id,
        }),
        success: (response) => {
          if (response.status === "success") {
            this.positions = response.data.map(item => ({
                position_id: item.position.id,
                position_name: item.position.name
            }));
          } else {
            Swal.fire({
              icon: "info",
              title: "No positions found",
              text: response.message,
              timer: 2500,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            });
          }
        },
        complete: () => {
          this.loading = false;
        },
      });
    },

    validationpositionForm() {
      this.errors = {};
      let valid = true;

      if (!this.position_name) {
        this.errors.position_name = 'Role name is required';
        valid = false;
      }

      return valid;
    },
    create_role() {
      if(!this.validationpositionForm()) {
        return;
      }
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('position_name', this.position_name.trim().charAt(0).toUpperCase() + this.position_name.trim().slice(1).toLowerCase());
      formData.append('portal_id', this.$route.params.portal_id);
      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_portal_position/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          Swal.close();
          Swal.fire({
            icon: 'success',
            title: 'position Created',
            text: 'position has been successfully created.',
            showConfirmButton: false,
            timer: 1000,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            const position = response.data;
            this.positions.unshift({
              position_id: position.position.id,
              position_name: position.position.name
            });
            $('#create_position').modal('hide');
          });
        },
        error: () => {
          Swal.close();
          this.errors.position_name="Role Name Already Exists"
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    open_edit_modal(position) {
      this.editingPosition.id = position.position_id;
      this.editingPosition.newName = position.position_name;
      this.showEditModal = true;
    },
    save_position_name() {
      if (!this.editingPosition.newName.trim()) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Position name cannot be empty",
          timer: 2500,
          showConfirmButton: false,
          position: 'bottom-end',
          toast: true
        });
        return;
      }
      this.edit_position_name(this.editingPosition.id, this.editingPosition.newName);
    },
    edit_position_name(positionId, newName) {
      this.loading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/edit_portal_position/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          position_id: positionId,
          position_name: newName
        }),
        success: (response) => {
          if (response.status === "success") {
            this.fetch_portal_position();
            Swal.fire({
              icon: "success",
              title: "Success",
              text: response.message,
              timer: 2500,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            });
            
            // Close the edit modal if it's open
            $('#edit_position_modal').modal('hide');
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "Failed to update position name",
              timer: 2500,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            });
          }
        },
        error: (xhr) => {
          const errorMessage = xhr.responseJSON?.message || "An error occurred while updating the position";
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorMessage,
            timer: 2500,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
          });
        },
        complete: () => {
          this.loading = false;
        },
      });
    },
    delete_position(positionId, portalId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "This position will be deleted from the portal!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_portal_position/`,
            method: "DELETE",
            headers: {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            },
            data: JSON.stringify({
              position_id: positionId,
              portal_id: portalId
            }),
            success: (response) => {
              if (response.status === "success") {
                // Remove the position from the local array
                this.positions = this.positions.filter(p => p.position_id !== positionId);
                Swal.fire({
                  icon: "success",
                  title: "Deleted!",
                  text: response.message,
                  timer: 2500,
                  showConfirmButton: false,
                  position: 'bottom-end',
                  toast: true
                })
              }
            },
            error: () =>{
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Cannot delete position because it is assigned to one or more users in this portal.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              })
            },
            complete: () => {
              this.loading = false;
            },
          });
        }
      });
    },

    fetchPortalUsers() {
      if (!this.portal_id) return;

      this.loading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
        method: "GET",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: { portal_id: this.portal_id },
        success: (response) =>{
          if (response.status === "success") {
            this.portalUsers = response.data.members;
            this.$nextTick(() => {
              this.initAssignPositionTable();
            });
          }
        },
        error: (xhr) => {
          console.error("Error fetching portal members:", xhr);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch portal members",
            timer: 2500,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
          });
        },
        complete: () => {
          this.loading = false;
        },
      });
    },

    isUserAssignedToPosition(user, positionId) {
    if (!user.user_portal_positions || !user.user_portal_positions.length) {
      return false;
    }
    // Check if any of the user’s portal positions match the current position
    return user.user_portal_positions.some(
      pos => pos.portal_position.position.id === positionId
    );
  },
    open_assign_modal(position) {
      this.selected_position = position;
      this.assignForm.userId = '';
      // Fetch portal users if not already loaded
      if (this.portalUsers.length === 0) {
        this.fetchPortalUsers();
      } else {
        this.$nextTick(() => {
          this.initAssignPositionTable();
        });
      }
    },
    initAssignPositionTable() {
      if (!$('#assignPositionTable').length) return;

      if ($.fn.DataTable.isDataTable('#assignPositionTable')) {
        $('#assignPositionTable').DataTable().destroy();
      }

      $('#assignPositionTable').DataTable({
        paging: true,
        searching: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next"
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available",
          search: "Search:"
        }
      });
    },

    handle_assign_position() {
      if (!this.assignForm.userId) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Please select a user",
          timer: 2500,
          showConfirmButton: false,
          position: 'bottom-end',
          toast: true
        });
        return;
      }

      this.assign_portal_position(
        this.assignForm.userId,
        this.selected_position.position_id,
        this.portal_id // Using portal_id as portal_access_id for now
      );

      // Close the modal
      $('#assign_position_modal').modal('hide');
    },

    assign_portal_position(userId, positionId) {
      this.loading = true;
      const base_url = `${window.location.origin}${this.$route.path}`;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/assign_portal_position/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          portal_id: this.portal_id,
          position_id: positionId,
          user_id: userId,
          base_url: base_url
        }),
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Position assigned successfully",
              timer: 2500,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            });
            const user = this.portalUsers.find(u => u.user.id === userId);
            if (user) {
              user.user_portal_positions.push({
                portal_position: { position: { id: positionId } }
              });
            }
            // Emit event for parent components
            this.$emit('position-assigned', response.data);
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "Failed to assign position",
              timer: 2500,
              showConfirmButton: false,
              position: 'bottom-end',
              toast: true
            });
          }
        },
        error: (xhr) => {
          const errorMessage = xhr.responseJSON?.message || "An error occurred while assigning the position";
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorMessage,
            timer: 2500,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
          });
        },
        complete: () => {
          this.loading = false;
        },
      });
    },
    unassign_portal_position(userId, positionId) {
      const base_url = `${window.location.origin}${this.$route.path}`;

      Swal.fire({
        title: 'Are you sure?',
        text: "You’re about to unassign this user from the position.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, unassign',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/unassign_portal_position/`,
            method: "DELETE",
            headers: {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            },
            data: JSON.stringify({
              portal_id: this.portal_id,
              position_id: positionId,
              user_id: userId,
              base_url: base_url
            }),
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  icon: "success",
                  title: "Unassigned!",
                  text: response.message || "User successfully unassigned from position",
                  timer: 2500,
                  showConfirmButton: false,
                  position: 'bottom-end',
                  toast: true
                });
                const user = this.portalUsers.find(u => u.user.id === userId);
                if (user && user.user_portal_positions) {
                  user.user_portal_positions = user.user_portal_positions.filter(
                    p => p.portal_position.position.id !== positionId
                  );
                }
                this.$emit('position-unassigned', { position_id: positionId, user_id: userId });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: response.message || "Failed to unassign user from position",
                  timer: 2500,
                  showConfirmButton: false,
                  position: 'bottom-end',
                  toast: true
                });
              }
            },
            error: (xhr) => {
              const errorMessage = xhr.responseJSON?.message || "An error occurred while unassigning the user";
              Swal.fire({
                icon: "error",
                title: "Error",
                text: errorMessage,
                timer: 2500,
                showConfirmButton: false,
                position: 'bottom-end',
                toast: true
              });
            },
            complete: () => {
              this.loading = false;
            },
          });
        }
      });
    },
  },
};
